(function ($) {
    //Scroll button
    $(".scrollDownBtn").click(function() {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            $('html,body').animate({scrollTop: $(".projectCategoryContainer").offset().top},'slow');
        } else if (/Android|webOS|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
            $('html,body').animate({scrollTop: $(".projectCategoryContainer").offset().top},'slow');
		} else {
            $('html,body').animate({scrollTop: $(".projectCategoryContainer").offset().top - 180},'slow');
        }
    });
    //Scroll up
    //Check to see if the window is top if not then display button
	$(window).scroll(function(){
		if ($(this).scrollTop() > 300) {
			var _footer_height = $('.footer').outerHeight();
			if($(window).scrollTop() + $(window).height() > $(document).height() - _footer_height ){
                if (/Android|iPhone|iPad|iPod|webOS|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
                    var new_height = parseFloat(_footer_height) + 20;
                }else {
                    var new_height = parseFloat(_footer_height) + 20;
                }
//				console.log(new_height);
				$('.scrollToTop').css('bottom', new_height +'px'); 
				$('.scrollToTop').fadeIn();				
			} else {
				$('.scrollToTop').css('bottom', '0px');
				$('.scrollToTop').fadeIn();
			}
		} else {
			$('.scrollToTop').fadeOut();
		}
	});
	
	//Click event to scroll to top
	$('.scrollToTop').click(function(){
		$('html, body').animate({scrollTop : 0},800);
		return false;
	});
    // Image slider for mobile
    $("#imageSlider-background > img:gt(0)").hide();

    setInterval(function() {
      $('#imageSlider-background > img:first')
        .fadeOut(3000)
        .next()
        .fadeIn(3000)
        .end()
        .appendTo('#imageSlider-background');
    }, 5000);    
    var $main = {
        asScrollTop: function ($) {
            $('.up-arrow a').on('click', function (e) {
                e.preventDefault();
                $('html body').animate({scrollTop: 0}, 700);
            });
        },
        inquiryValidation: function ($) {
            $('.inquiry-form form').validate({
                rules: {
                    name: {
                        noJustWhiteSpace: true
                    },
                    'contact-name-sei': {
                        noJustWhiteSpace: true
                    },
                    'contact-name-mei': {
                        noJustWhiteSpace: true
                    },
                    phone: {
                        noJustWhiteSpace: true,
                        isPhoneNumber : true
                    }
                    ,
                    email: {
                        noJustWhiteSpace: true
                    }
                }
            });
        },
        commonTask: function ($) {
            $.extend($.validator.messages, {
                required: "ご記入ください",
                email: "有効なメールアドレスをご記入ください。"
            });

            $('.category ul li').on('click', function () {
                $('.category .active').removeClass('active');
                $(this).addClass('active');
                var $id = $(this).find('a').attr('href');
                $('html,body').animate({
                        scrollTop: $($id).offset().top - 80
                    },
                    500);
            });

            $('.projects-type-changer-js').on('change', function () {
                if($(this).val().length){
                    window.location = $(this).val();
                }
            });
        },

        stickyNav: function ($) {

            var shrinkHeader = 32;

            $(window).scroll(function () {
                var scroll = getCurrentScroll();
                if (scroll >= shrinkHeader) {
                    $('#mainNav').addClass('sticky');
                }
                else {
                    $('#mainNav').removeClass('sticky');
                }
            });
            
            $(window).scroll(function () {
				if( $('.js-main-nav').length ){
					var _banner_height = $('.headerHeroContainer').outerHeight(true) ;
					var _offset_height = $('.js-main-nav').offset().top + _banner_height;
					if( $(window).scrollTop() >=  _banner_height ){
						$('.js-main-nav').addClass('sticky').css({"top":"0"});
					} else {
						$('.js-main-nav').removeClass('sticky').css({"top":"-100%"});
					}
				}
            });
            
            function getCurrentScroll() {
                return window.pageYOffset || document.documentElement.scrollTop;
            }


        },
        stickyNav2: function ($) {

            var shrinkHeader = 892;
            var $directorSection = $('.directors');
            var $directorCategory = $('.category');
            var h4Height = $directorCategory.find('h4').height() + 30;
            var ulHeight = $directorCategory.find('ul').height();
            var contactButton = $directorCategory.find('.aside-contact-button').height() + 30;
            var $directorHeight = $directorSection.height();


            $(window).scroll(function () {
                var scroll = getCurrentScroll();
                if (scroll >= shrinkHeader && scroll <= (($directorHeight + shrinkHeader + 60) - (h4Height + ulHeight + contactButton))) {
                    $('.directors').addClass('sticky-sidebar');
                }
                else {
                    $('.directors').removeClass('sticky-sidebar');
                }
            });
            function getCurrentScroll() {
                return window.pageYOffset || document.documentElement.scrollTop;
            }


        },
        slickCarousel: function ($) {
            var $slides = $('.slides');
            var slick = $slides.slick({
                nextArrow: $('.member__slider .navigator .right'),
                prevArrow: $('.member__slider .navigator .left'),
                autoplay: true,
                autoplaySpeed: 3000,
                cssEase: 'ease',
                mobileFirst: true

            });
            var eachSlide = $slides.find('.slide:not(.slick-cloned)');
            eachSlide.each(function (index) {
                var $a = $('<a>');
                if (index == 0) {
                    $a.addClass('active');
                }
                $a.attr('href', '#');
                $a.attr('slide-target', index);
                $('.slide--counter').append($a);
            });

            $(document).on('click', '.slide--counter a', function (e) {
                e.preventDefault();
                $('.slide--counter a.active').removeClass('active');
                $(this).addClass('active');
                $slides.slick('slickGoTo', $(this).attr('slide-target'));
            });
            slick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $('.slide--counter a.active').removeClass('active');
                $('.slide--counter a:nth-child(' + (nextSlide + 1) + ')').addClass('active');
            })
        },

        mobileNav: function ($) {
            var navBtn = $('.mobile-menu-trigger');
            var mobNav = $('#mobileMenu');
            var width = $(window).width();
            navBtn.on('click', function (e) {
                e.preventDefault();
//                mobNav.toggleClass('active');
                if ($('#mobileMenu').hasClass('active')){
                    $('#mobileMenu').removeClass('active');
                    $('body').css('position','relative');
                    $('body').css('z-index','unset');
                } else {
                    $('#mobileMenu').addClass('active');
                    $('body').css('position','fixed');
                    $('body').css('z-index','0');
                }
            });

        },
        noJustWhiteSpace: function ($) {
            $.validator.addMethod("noJustWhiteSpace", function (value, element) {
                return value.trim().length > 0;
            }, "ご記入ください");
        },
        isPhoneNumber: function ($) {
            $.validator.addMethod("isPhoneNumber", function (value, element) {
                var phone_pattern = /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/; 
				// var isValid = phone_pattern.test( value );
                return phone_pattern.test( value );
            }, "間違った電話番号");
        },
        init: function ($) {
            this.commonTask($);
            this.asScrollTop($);
            this.noJustWhiteSpace($);
            this.isPhoneNumber($);
            this.inquiryValidation($);
            this.stickyNav($);
            this.stickyNav2($);
            this.mobileNav($);
            this.slickCarousel($);
        }
    };
    $main.init($);
}(jQuery));